import React, { useEffect } from 'react';
import { getFieldValue } from '@sitecore-jss/sitecore-jss-react';
import useMouseflowTracking from 'utils/hooks/useMouseflowTracking';

const Mouseflow = ({ fields }) => {
  const tags = getFieldValue(fields, 'tags');
  const { mouseflowTrackingURL } = useMouseflowTracking();
  useEffect(() => {
    if (mouseflowTrackingURL) {
      if (tags) {
        if (typeof window !== 'undefined' && window._mfq) {
          if (tags.communityPage) window._mfq.push(['tag', 'Community Page']);
          if (tags.janePage) window._mfq.push(['tag', 'Jane Page']);
          if (tags.marketPage) window._mfq.push(['tag', 'Market Page']);
          if (tags.mpcPage) window._mfq.push(['tag', 'MPC Page']);
          if (tags.planPage) window._mfq.push(['tag', 'Plan Page']);
          if (tags.promoPage) window._mfq.push(['tag', 'Promo Page']);
          if (tags.qmiPage) window._mfq.push(['tag', 'QMI Page']);
          if (tags.promoPage) window._mfq.push(['tag', 'Promo Page']);
          if (tags.mpcCode) window._mfq.push(['tag', tags.mpcCode]);
          if (tags.mpcName) window._mfq.push(['tag', tags.mpcName]);
          if (tags.communityName) window._mfq.push(['tag', tags.communityName]);
          if (tags.divisionCode) window._mfq.push(['tag', tags.divisionCode]);
          if (tags.marketName) window._mfq.push(['tag', tags.marketName]);
          if (tags.promoCode) window._mfq.push(['tag', tags.promoCode]);
        }
      }
    }
  }, [mouseflowTrackingURL, tags]);

  return '';
};

export default Mouseflow;
